/** The languages a terms / privacy text can be written in (same three as the apps). */
export const LEGAL_LANGUAGES = ["zh", "en", "ms"];
/** The app's current UI language ("zh-CN", "en", "ms-MY"…) as the language of the legal text to show. */
export const legalLang = (uiLanguage) => {
    const l = (uiLanguage ?? "").slice(0, 2).toLowerCase();
    return l === "zh" || l === "ms" ? l : "en";
};
//# sourceMappingURL=legal.js.map